import { onMounted, onUnmounted, ref, watch } from "vue";

type GraphProfile = {
  displayName?: string;
  userPrincipalName?: string;
};

type GraphGroupResponse = {
  value?: Array<{ displayName?: string }>;
};

export const usePortalPageViewTracking = () => {
  const route = useRoute();
  const { $profileInfo, $memberGroup } = useNuxtApp();

  const profile = ref<GraphProfile | null>(null);
  const store = ref("");
  const lastSentPath = ref("");
  let stopWatcher: null | (() => void) = null;

  const loadIdentityContext = async () => {
    if (profile.value && store.value) return;

    const profileInfo = (await $profileInfo?.()) as GraphProfile | null;
    const groups = (await $memberGroup?.()) as GraphGroupResponse | null;

    profile.value = profileInfo || null;

    const firstStoreGroup =
      groups?.value
        ?.map((g) => (g?.displayName || "").trim())
        .find((name) => name.startsWith("Store-")) || "";

    store.value = firstStoreGroup;
  };

  const trackPath = async (path: string) => {
    if (!import.meta.client) return;
    if (!path.startsWith("/portal")) return;
    if (path === lastSentPath.value) return;

    await loadIdentityContext();

    const optician = (profile.value?.displayName || "").trim();
    const email = (profile.value?.userPrincipalName || "").trim();
    const storeValue = (store.value || "").trim();

    if (!storeValue || !optician || !email) {
      return;
    }

    try {
      await useApiFetch("/api/pushPageView", {
        method: "POST",
        body: {
          store: storeValue,
          optician,
          email,
          pageviewed: path,
        },
      });

      lastSentPath.value = path;
    } catch (error) {
      console.error("Failed to push page view:", error);
    }
  };

  onMounted(async () => {
    await trackPath(route.path);

    stopWatcher = watch(
      () => route.path,
      async (newPath) => {
        await trackPath(newPath);
      }
    );
  });

  onUnmounted(() => {
    if (stopWatcher) stopWatcher();
  });
};